import React, { useMemo } from 'react';

import { useMyAccount } from '../../shared/hooks/hooks';

import { formatCurrency } from '../../shared/utils/format/format';

import {
  MarkDownPriceType,
  Maybe,
  ProductData
} from '../../shared/types/graphql-types';

import './stacked-markdown-price.scss';

interface StackedMarkdownPriceProps {
  hidePercentageSaved?: boolean;
  product?: Maybe<ProductData>;
}

function StackedMarkdownPrice(props: StackedMarkdownPriceProps) {
  const { hidePercentageSaved = false, product } = props;

  const { isFleetAccount } = useMyAccount();

  const { markDownPriceType, originalPrice, percentageSaved } = useMemo(() => {
    const { mapDisplayRule, mapPrice } = product || {};

    if (!mapPrice || (mapPrice && mapDisplayRule?.mapPriceDisplay)) {
      return {
        markDownPriceType: product?.markdownPriceData?.markDownPriceType,
        originalPrice: Number(product?.markdownPriceData?.originalRetailValue),
        percentageSaved: product?.markdownPriceData?.formattedPercentageSaved
      };
    } else {
      return {
        markDownPriceType: null,
        originalPrice: 0,
        percentageSaved: null
      };
    }
  }, [product]);

  if ((isNaN(originalPrice) || originalPrice === 0) && !percentageSaved)
    return null;

  return (
    <div className="stacked-markdown-price" styleName="container">
      <div className="stacked-markdown-price__markdown" styleName="markdown">
        {!isNaN(originalPrice) && (
          <div
            className="stacked-markdown-price__original-price"
            styleName="original-price"
          >
            {formatCurrency(originalPrice)}
          </div>
        )}
        {percentageSaved && !hidePercentageSaved && (
          <div styleName="percentage-saved">
            {process.env.__FF_FLEET_ACCOUNT__ === 'true' &&
            isFleetAccount &&
            markDownPriceType === MarkDownPriceType?.Fleet
              ? 'Fleet Discount'
              : 'Save'}
            &nbsp;{percentageSaved}
          </div>
        )}
      </div>
    </div>
  );
}

export default StackedMarkdownPrice;
